export const getBasePath = () =>
  window.spa_variables.basePath === '/' ? '' : window.spa_variables.basePath;

export const getUrlFor = (route: string) =>
  new URL(`${getBasePath()}${route}`, window.location.origin);
